import client from '@/apis/aniftyBackend/client';

import { AniftyTokenDetailData } from './interface';

// const getTokenDetailMock = async (
//   aniftyTokenID: number
// ): Promise<AniftyTokenDetailData> => {
//   return new Promise((resolve) => {
//     setTimeout(() => {
//       resolve({
//         aniftyTokenID: aniftyTokenID,
//         tokenImageURL: '/images/sample-maki-sensei.png',
//         imageWidth: 3000,
//         imageHeight: 4763,
//         titleJA: '煙草',
//         titleEN: 'cigarettes',
//         descriptionJA: 'This is mock test',
//         descriptionEN: 'text text text text text text',
//         totalTokenAmount: 5,
//         availableTokenAmount: 1,
//         priceTokenTicker: 'ETH',
//         currentETHPrice: 2000,

//         // Creator Info
//         creatorInfo: {
//           publicAddress: '0xb1839cEa93BdFdF29E08ae3F351813fe7E89afB4',
//           nameEN: 'makihitsuji',
//           nameJA: '巻羊',
//           primarySellingTokenInfo: {
//             saleListingID: 1,
//             price: parseEther('0.4').toString(),
//           },
//         },

//         // Owner Info
//         ownersInfo: [
//           {
//             displayName: 'Sample User',
//             publicAddress: '0xC1839cEa93BdFdF29E08ae3F351813fe7E89afB3',
//             numHoldingTokens: 4,
//             numOnSaleTokens: 3,
//             profileImageURL:
//               '/images/user-profile-page/default-profile-picture.png',
//             sellingTokenInfo: [
//               {
//                 saleListingID: 1,
//                 price: '2',
//               },
//               {
//                 saleListingID: 2,
//                 price: '0.5',
//               },
//               {
//                 saleListingID: 3,
//                 price: '0.1',
//               },
//             ],
//           },
//           {
//             displayName: 'Joanna',
//             publicAddress: '0xC1839cEa93BdFdF29E08ae3F351813fe7E89afB3',
//             numHoldingTokens: 2,
//             numOnSaleTokens: 0,
//             profileImageURL:
//               '/images/user-profile-page/default-profile-picture.png',
//             sellingTokenInfo: null,
//           },
//         ],
//       });
//     }, 1000);
//   });
// };

export const fetchTokenByID = async (
  aniftyTokenID: number
): Promise<AniftyTokenDetailData> => {
  const response = await client.get<AniftyTokenDetailData>(
    `/api/anifty_tokens/${aniftyTokenID}`
  );
  return response.data;
};
